import { Page } from 'layouts/Page';
import React from 'react';

const Home = (): JSX.Element => {
  return <Page title="Home"></Page>;
};

export default Home;
